import { useState } from "react";
import { Lock, Copy, Check, Download, Volume2, Mic, AlertCircle, BookOpen, ChevronRight, Film } from "lucide-react";

const AUDIOS = Object.fromEntries(
  Array.from({ length: 19 }, (_, i) => [i + 1, `/audios/setter-${i + 1}.ogg`])
);

const GROUPS = [
  {
    grupo: "Grupo 1 · Primer contacto y bienvenida",
    scripts: [
      { n: 1, title: "Bienvenida / primer contacto", text: "¡Hola! Te habla Carlos, Carlos Miami Fernández. Qué alegría que diste el primer paso. Mira, yo empecé desde abajo, igual que muchos, y hoy ayudo a miles de personas en más de veinte países a generar ingresos con el mundo de los viajes, sin tener que emigrar. Quiero que tú también lo veas con tus propios ojos. Por eso te invito a nuestro próximo webinar en vivo, totalmente gratis, donde te muestro exactamente cómo funciona. Acompáñame, que esto te puede cambiar el año. ¡Te espero!" },
    ],
  },
  {
    grupo: "Grupo 2 · Seguimiento cuando no contesta",
    scripts: [
      { n: 2, title: "No contesta — seguimiento 1 (suave)", text: "¡Hola! Soy Carlos Miami. Te escribo porque te aparté un lugar y no quiero que se quede vacío. Sé que el día está lleno de cosas, a mí también me pasa, así que tranquilo. Solo dime: ¿te late que te cuente cómo estamos ayudando a la gente a generar ingresos con los viajes? Es información muy valiosa y es gratis. Cuando puedas, me das una señalita por aquí. ¡Un abrazo!" },
      { n: 3, title: "No contesta — seguimiento 2 (aporta valor)", text: "Hola, de nuevo Carlos Miami. No quiero ser intenso, solo insistir una vez más, porque de verdad creo que esto vale tu tiempo. Imagínate poder generar ingresos extra desde tu celular, ayudando a la gente a viajar. Eso es justo lo que hacemos, y en el webinar te lo explico paso a paso, sin compromiso. Si te interesa, mándame un “sí” por aquí y te paso los datos. ¡Quedo pendiente de ti!" },
      { n: 4, title: "No contesta — último intento (puerta abierta)", text: "Hola, te habla Carlos. Este es mi último mensajito por ahora, no te preocupes. Entiendo perfecto si este no es tu momento. Solo quiero que sepas que la puerta queda abierta: el día que quieras conocer cómo generar ingresos con los viajes, aquí voy a estar para ayudarte. Si todavía te interesa, una palabrita y retomamos. Te mando un fuerte abrazo y te deseo lo mejor." },
    ],
  },
  {
    grupo: "Grupo 3 · Cuando hay interés y dudas",
    scripts: [
      { n: 5, title: "Interesado — siguiente paso", text: "¡Eso me encanta! Soy Carlos Miami. Me alegra muchísimo que te interese, porque la gente que da este paso es la que termina cambiando su historia. El mejor siguiente paso es que entres a nuestro webinar en vivo, donde te muestro todo: cómo funciona, cuánto se puede generar y cómo empezar. Es gratis y en vivo, así que puedes preguntarme lo que quieras. Confírmame por aquí y te aparto tu lugar. ¡Vamos con todo!" },
      { n: 6, title: "¿Qué plan te interesa?", text: "Hola, soy Carlos Miami. Me cuentas que estás viendo los planes, y me parece excelente. Mira, para no marearte con tanta información, lo mejor es que en el webinar te explico cada opción y juntos vemos cuál encaja contigo y con tu meta. Cada persona es distinta, y la idea es que elijas con claridad, no a ciegas. Acompáñame a la próxima sesión en vivo y ahí te ayudo a decidir. Dime que sí y te paso los datos." },
      { n: 7, title: "¿Necesitas ayuda adicional?", text: "¡Hola! Te habla Carlos Miami. Quiero asegurarme de que no te quedes con ninguna duda. Si algo no te quedó claro o necesitas que te explique algo en especial, aquí estoy para ayudarte, de verdad. Lo más completo es que lo veas en el webinar en vivo, porque ahí respondo todo en el momento. Pero si tienes una duda puntual, mándamela por aquí y con gusto te apoyo. No estás solo en esto." },
      { n: 8, title: "¿Quieres una cita conmigo?", text: "Hola, soy Carlos Miami. Me preguntas si podemos hablar uno a uno, y claro que sí, con mucho gusto. Para aprovechar bien ese tiempo, te pido un favor: primero acompáñame al webinar en vivo, porque ahí ves el panorama completo. Después, si quieres, agendamos una llamada personal para resolver tus dudas y ver tu caso. Así nuestra conversación rinde el doble. ¿Te parece? Confírmame y empezamos por el webinar." },
    ],
  },
  {
    grupo: "Grupo 4 · Webinar: recordatorios y después",
    scripts: [
      { n: 9, title: "Recordatorio — un día antes", text: "¡Hola! Carlos Miami por aquí. Mañana es el día. Quiero recordarte que tenemos nuestro webinar en vivo y aparté un lugar para ti. No faltes, porque lo que voy a compartir te puede abrir una puerta importante. Conéctate con tiempo, con calma y con muchas ganas de aprender. Revisa el mensaje con la hora y el enlace. ¡Nos vemos mañana, te espero sin falta!" },
      { n: 10, title: "Recordatorio — hoy es el día", text: "¡Hoy es el día! Te habla Carlos Miami. Hoy nos vemos en el webinar en vivo. Prepárate, busca un lugar tranquilo y ten papel y lápiz a la mano, porque vamos a hablar de cómo generar ingresos con los viajes. Tu lugar está apartado, solo faltas tú. Revisa el mensaje con la hora y el enlace, y nos vemos hoy. ¡Ahí te espero!" },
      { n: 11, title: "Está por empezar — entra ahora", text: "¡Estamos por comenzar! Soy Carlos Miami. El webinar arranca en unos minutos y no quiero que te lo pierdas. Deja lo que estés haciendo, toma tu celular o tu computadora y entra ya con el enlace que te mandé. Lo bueno empieza desde el minuto uno. ¡Te veo adentro, vamos!" },
      { n: 12, title: "No asistió — segunda oportunidad", text: "Hola, soy Carlos Miami. Te extrañé en el webinar, te había guardado tu lugar. Pero tranquilo, la vida pasa y lo entiendo. La buena noticia es que tenemos otra sesión en vivo muy pronto, y quiero que esta vez sí estés. De verdad creo que esto puede sumarle mucho a tu vida. Dime que sí y te aparto tu lugar para la próxima. No lo dejes pasar otra vez, ¿va?" },
      { n: 13, title: "¿Qué te pareció? (post-webinar)", text: "¡Hola! Carlos Miami por aquí. Te vi en el webinar, ¡gracias por acompañarme! Me encantaría saber, con toda sinceridad: ¿qué te pareció? ¿Qué fue lo que más te gustó o qué te dejó pensando? Cuéntame por aquí, porque según lo que me digas, te ayudo a dar el siguiente paso de la mejor forma para ti. Quedo muy atento a tu respuesta, ¿sí?" },
    ],
  },
  {
    grupo: "Grupo 5 · Manejo de objeciones",
    scripts: [
      { n: 14, title: "“No tengo tiempo”", text: "Hola, soy Carlos Miami. Me dices que andas sin tiempo y, ¿sabes qué?, te entiendo perfecto, todos andamos corriendo. Pero déjame decirte algo: precisamente por eso esto te puede servir, porque se trata de generar ingresos sin dejar lo que ya haces, desde tu celular y a tu propio ritmo. El webinar es una sola hora que te puede ahorrar muchas. Conéctate aunque sea desde donde estés. ¿Te aparto tu lugar?" },
      { n: 15, title: "“¿Cuánto cuesta?” / “Es mucho dinero”", text: "Hola, te habla Carlos Miami. Veo que te preocupa la inversión, y me parece muy responsable de tu parte preguntarlo. Mira, hay opciones para distintos bolsillos, y lo más importante no es cuánto cuesta, sino cuánto puedes llegar a generar. Eso lo vas a entender clarísimo en el webinar, donde te muestro los números reales y cómo se recupera. Acompáñame, míralo completo y después decides con tranquilidad. ¿Te parece justo?" },
      { n: 16, title: "“Déjame pensarlo”", text: "Hola, soy Carlos Miami. Me dices que lo quieres pensar, y me parece perfecto, las buenas decisiones se piensan. Solo te pido una cosa: piénsalo con toda la información, no a medias. Por eso, antes de decidir, acompáñame al webinar en vivo; ahí vas a tener todo lo que necesitas para pensarlo bien. Y si después decides que no es para ti, no pasa nada, quedamos como amigos. ¿Te aparto el lugar para que lo veas completo?" },
    ],
  },
  {
    grupo: "Grupo 6 · Reactivación y cierre",
    scripts: [
      { n: 17, title: "Reactivación — lead frío", text: "¡Hola! ¿Cómo has estado? Te habla Carlos Miami. Hace un tiempo mostraste interés en lo que hacemos y se nos perdió el contacto, ¡pero no me olvidé de ti! Te escribo porque las cosas han crecido muchísimo y hoy hay más oportunidades que nunca para generar ingresos con los viajes. Si todavía te llama la atención, me encantaría que entres a nuestro próximo webinar en vivo y lo veas tú mismo. Dime una palabrita y retomamos donde lo dejamos. ¡Un abrazo grande!" },
      { n: 18, title: "Motivación / empujón final", text: "Te habla Carlos Miami, y quiero hablarte de corazón. Yo sé lo que es querer algo más para uno y para su familia. También sé lo que es atreverse. La diferencia entre los que cambian su vida y los que se quedan igual no es el talento, es dar el paso. Hoy te estoy dando la mano para que des el tuyo. Acompáñame al webinar, escúchame una hora, y decide con el corazón y con la cabeza. Yo creo en ti. ¿Vamos juntos?" },
    ],
  },
  {
    grupo: "Grupo 7 · Confirmación (baja el ausentismo)",
    scripts: [
      { n: 19, title: "Confirmación — “ya aparté tu lugar”", text: "¡Excelente decisión! Soy Carlos Miami. Ya quedó: te aparté tu lugar para el webinar en vivo, así que cuenta con él. Te pido solo una cosa: agéndalo como una cita importante contigo mismo, porque lo es. Pon una alarma, búscate un lugar tranquilo y llega con la mente abierta. Yo voy a estar ahí, en vivo, para ti. Nos vemos muy pronto. ¡Qué gusto tenerte!" },
    ],
  },
];

const ScriptCard = ({ s }) => {
  const [copied, setCopied] = useState(false);
  const [dl, setDl] = useState(false);
  const audio = AUDIOS[s.n];

  const copyText = async () => {
    try {
      await navigator.clipboard.writeText(s.text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = s.text; document.body.appendChild(ta); ta.select();
      document.execCommand("copy"); document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const downloadAudio = async () => {
    setDl(true);
    try {
      const res = await fetch(audio);
      const blob = await res.blob();
      const href = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = href;
      a.download = `Setter ${s.n} - ${s.title}.ogg`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(href);
    } catch {
      window.open(audio, "_blank");
    } finally {
      setDl(false);
    }
  };

  return (
    <div data-testid={`script-card-${s.n}`} className="bg-white dark:bg-slate-800/50 rounded-2xl border border-slate-200 dark:border-slate-700 p-5">
      <div className="flex items-start gap-3 mb-3">
        <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#1D1D1B] text-white flex items-center justify-center text-sm font-black">{s.n}</span>
        <h3 className="text-base font-bold text-[#1D1D1B] dark:text-white leading-tight pt-1">{s.title}</h3>
      </div>

      <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed whitespace-pre-wrap mb-4">{s.text}</p>

      <div className="flex flex-wrap items-center gap-2">
        <button type="button" data-testid={`copy-${s.n}`} onClick={copyText}
          className="inline-flex items-center gap-1.5 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 text-slate-700 dark:text-slate-200 font-bold px-3.5 py-2 rounded-lg text-xs">
          {copied ? <><Check className="h-3.5 w-3.5 text-[#80C753]" /> ¡Copiado!</> : <><Copy className="h-3.5 w-3.5" /> Copiar texto</>}
        </button>
      </div>

      {audio ? (
        <div className="mt-4 bg-[#80C753]/5 border border-[#80C753]/25 rounded-xl p-3">
          <div className="flex items-center gap-2 mb-2 text-[#5a9b36] text-xs font-bold uppercase tracking-wide">
            <Volume2 className="h-3.5 w-3.5" /> Grabación
          </div>
          <audio data-testid={`audio-${s.n}`} src={audio} type="audio/ogg" controls preload="none" className="w-full h-10" />
          <button type="button" data-testid={`download-audio-${s.n}`} onClick={downloadAudio} disabled={dl}
            className="mt-2 w-full inline-flex items-center justify-center gap-2 bg-[#80C753] hover:bg-[#6fb145] text-white font-bold px-4 py-2.5 rounded-lg text-xs uppercase tracking-wide disabled:opacity-60">
            {dl ? "Descargando..." : <><Download className="h-3.5 w-3.5" /> Descargar audio</>}
          </button>
        </div>
      ) : (
        <div className="mt-4 flex items-center gap-2 text-[11px] text-slate-400 bg-slate-50 dark:bg-slate-800 border border-dashed border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2">
          <Mic className="h-3.5 w-3.5" /> Grabación pendiente
        </div>
      )}
    </div>
  );
};

const SetterScriptsPage = () => {
  const withAudio = Object.keys(AUDIOS).length;
  return (
    <div data-testid="setter-scripts-page" className="min-h-screen bg-slate-50 dark:bg-[#0a0e1a]">
      <header className="border-b border-slate-200 dark:border-slate-700 bg-[#1D1D1B]">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <Lock className="h-5 w-5 text-[#c9a227]" />
          <div>
            <p className="text-white font-bold text-sm">Sistema de Setters · Uso interno privado</p>
            <p className="text-slate-400 text-[11px]">Club Viajemos · Travel Empire — Guiones de locución para WhatsApp</p>
          </div>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Instrucciones */}
        <div className="bg-white dark:bg-slate-800/50 rounded-2xl border border-slate-200 dark:border-slate-700 p-5 mb-6">
          <h1 className="text-2xl font-black text-[#1D1D1B] dark:text-white mb-2">Guiones de locución — Línea de Setter</h1>
          <p className="text-sm text-slate-600 dark:text-slate-300 mb-3">
            Cada guion tiene su texto y su grabación correspondiente. <strong>Copia el texto</strong> y <strong>descarga el audio</strong> para enviarlos por WhatsApp a tus prospectos. Todos dirigen al webinar en vivo.
          </p>
          <div className="flex items-start gap-2 bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800/30 rounded-lg p-3 text-xs text-amber-700 dark:text-amber-400">
            <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
            <span>Página privada de uso exclusivo del equipo de setters. No la compartas con prospectos. Actualmente {withAudio} de {GROUPS.reduce((a, g) => a + g.scripts.length, 0)} guiones tienen grabación cargada.</span>
          </div>
        </div>

        {/* Proyecto de Vida de Carlos para leer */}
        <a
          href="/proyecto-de-vida-carlos.html"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="proyecto-vida-link"
          className="flex items-center gap-4 bg-gradient-to-r from-[#1D1D1B] to-[#2b2b28] rounded-2xl border border-[#c9a227]/40 p-5 mb-6 hover:border-[#c9a227] transition-colors group"
        >
          <span className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#c9a227]/15 flex items-center justify-center">
            <BookOpen className="h-6 w-6 text-[#c9a227]" />
          </span>
          <div className="flex-1">
            <h2 className="text-white font-black text-base leading-tight">Proyecto de Vida — Carlos «Miami» Fernández</h2>
            <p className="text-slate-400 text-xs mt-0.5">Lectura para el equipo de setters · toca para leer</p>
          </div>
          <span className="flex-shrink-0 inline-flex items-center gap-1.5 text-[#c9a227] font-bold text-xs uppercase tracking-wide group-hover:translate-x-0.5 transition-transform">
            Leer <ChevronRight className="h-4 w-4" />
          </span>
        </a>

        {/* Link: Valor de Leads de Hoy */}
        <a
          href="/leads"
          data-testid="valor-leads-link"
          className="flex items-center gap-4 bg-gradient-to-r from-[#0f3d24] to-[#1c6b3f] rounded-2xl border border-[#80C753]/50 p-5 mb-6 hover:border-[#80C753] transition-colors group"
        >
          <span className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#80C753]/20 flex items-center justify-center">
            <Volume2 className="h-6 w-6 text-[#80C753]" />
          </span>
          <div className="flex-1">
            <h2 className="text-white font-black text-base leading-tight">Valor de Leads de Hoy</h2>
            <p className="text-slate-300 text-xs mt-0.5">Consulta el tablero de precios por lead · toca para ver</p>
          </div>
          <span className="flex-shrink-0 inline-flex items-center gap-1.5 text-[#80C753] font-bold text-xs uppercase tracking-wide group-hover:translate-x-0.5 transition-transform">
            Ver <ChevronRight className="h-4 w-4" />
          </span>
        </a>

        {/* Banner: videos y diseños en Comunidad */}
        <a
          href="/comunidad"
          data-testid="comunidad-banner"
          className="flex items-center gap-4 bg-gradient-to-r from-[#0A1E3F] to-[#123a6b] rounded-2xl border border-[#45A0EE]/40 p-5 mb-6 hover:border-[#45A0EE] transition-colors group"
        >
          <span className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#45A0EE]/20 flex items-center justify-center">
            <Film className="h-6 w-6 text-[#45A0EE]" />
          </span>
          <div className="flex-1">
            <h2 className="text-white font-black text-base leading-tight">¿Quieres enviar videos y diseños?</h2>
            <p className="text-slate-300 text-xs mt-0.5">Encuéntralos todos en clubviajemos.com/comunidad</p>
          </div>
          <span className="flex-shrink-0 inline-flex items-center gap-1.5 text-[#45A0EE] font-bold text-xs uppercase tracking-wide group-hover:translate-x-0.5 transition-transform">
            Ir <ChevronRight className="h-4 w-4" />
          </span>
        </a>

        {/* Curso para leer */}
        <a
          href="/curso-magia-primer-contacto.html"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="curso-magia-link"
          className="flex items-center gap-4 bg-gradient-to-r from-[#1D1D1B] to-[#2b2b28] rounded-2xl border border-[#c9a227]/40 p-5 mb-6 hover:border-[#c9a227] transition-colors group"
        >
          <span className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#c9a227]/15 flex items-center justify-center">
            <BookOpen className="h-6 w-6 text-[#c9a227]" />
          </span>
          <div className="flex-1">
            <h2 className="text-white font-black text-base leading-tight">La Magia del Primer Contacto</h2>
            <p className="text-slate-400 text-xs mt-0.5">Curso de lectura para el equipo de setters · toca para leer</p>
          </div>
          <span className="flex-shrink-0 inline-flex items-center gap-1.5 text-[#c9a227] font-bold text-xs uppercase tracking-wide group-hover:translate-x-0.5 transition-transform">
            Leer <ChevronRight className="h-4 w-4" />
          </span>
        </a>

        {/* Biblia del Setter para leer */}
        <a
          href="/biblia-del-setter.html"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="biblia-setter-link"
          className="flex items-center gap-4 bg-gradient-to-r from-[#1D1D1B] to-[#2b2b28] rounded-2xl border border-[#c9a227]/40 p-5 mb-6 hover:border-[#c9a227] transition-colors group"
        >
          <span className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#c9a227]/15 flex items-center justify-center">
            <BookOpen className="h-6 w-6 text-[#c9a227]" />
          </span>
          <div className="flex-1">
            <h2 className="text-white font-black text-base leading-tight">La Biblia del Setter</h2>
            <p className="text-slate-400 text-xs mt-0.5">Guía completa de lectura para el equipo de setters · toca para leer</p>
          </div>
          <span className="flex-shrink-0 inline-flex items-center gap-1.5 text-[#c9a227] font-bold text-xs uppercase tracking-wide group-hover:translate-x-0.5 transition-transform">
            Leer <ChevronRight className="h-4 w-4" />
          </span>
        </a>

        {GROUPS.map((g) => (
          <section key={g.grupo} className="mb-8">
            <h2 className="text-xs font-black uppercase tracking-[0.15em] text-[#c9a227] mb-3">{g.grupo}</h2>
            <div className="space-y-4">
              {g.scripts.map((s) => <ScriptCard key={s.n} s={s} />)}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default SetterScriptsPage;
